import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Search, User, X } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";
import { useSpace } from "@/context/SpaceContext";
import { APP_NAME } from "@/lib/brand";

const ViewingAs = () => {
  const { space, setSpace } = useSpace();
  if (!space.startsWith("user:")) return null;
  return (
    <div className="space-switch" data-testid="viewing-as">
      <span className="px-3 text-xs" data-testid="viewing-as-chip">Viewing {sessionStorage.getItem("fa-view-name") || "another"}'s library</span>
      <button className="on" onClick={() => setSpace("all")} data-testid="viewing-as-exit">Exit</button>
    </div>
  );
};

const SearchBox = () => {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const submit = (e) => {
    e.preventDefault();
    if (q.trim()) navigate(`/search?q=${encodeURIComponent(q.trim())}`);
  };
  return (
    <form onSubmit={submit} className={`topbar-search ${open ? "open" : ""}`} data-testid="search-form">
      <button type="button" className="icon-btn md:hidden" onClick={() => setOpen(!open)} aria-label="Search" data-testid="search-toggle">
        {open ? <X size={18} /> : <Search size={18} />}
      </button>
      <Search size={15} className="topbar-search-icon" />
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search: beach hawaii, halloween 2022…" data-testid="search-input" />
    </form>
  );
};

export const TopBar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const nav = ({ isActive }) => `topbar-link ${isActive ? "on" : ""}`;
  return (
    <header className="topbar" data-testid="topbar">
      <Link to="/" className="serif topbar-logo" data-testid="nav-logo" aria-label={APP_NAME}><span className="hidden sm:inline">{APP_NAME}</span><span className="sm:hidden">{APP_NAME.split(" ")[0]}</span></Link>
      <nav className="hidden md:flex items-center gap-1">
        <NavLink to="/" end className={nav} data-testid="nav-link-albums">Albums</NavLink>
      </nav>
      <ViewingAs />
      <SearchBox />
      <div className="topbar-right flex items-center gap-2 ml-auto">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="icon-btn" aria-label="Account" data-testid="user-menu-button">
              {user?.picture ? <img src={user.picture} alt="" className="w-7 h-7 rounded-full" /> : <User size={18} />}
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-52">
            <DropdownMenuLabel className="truncate" data-testid="user-menu-email">{user?.email}</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem className="md:hidden" onClick={() => navigate("/")} data-testid="menu-albums">Albums</DropdownMenuItem>
            <DropdownMenuItem onClick={() => navigate("/import")} data-testid="nav-link-import">Import photos</DropdownMenuItem>
            {user?.role === "admin" && <DropdownMenuItem onClick={() => navigate("/library")} data-testid="nav-link-photo-library">Photo Library</DropdownMenuItem>}
            {user?.role === "admin" && <DropdownMenuItem onClick={() => navigate("/duplicates")} data-testid="nav-link-duplicates">Hidden duplicates</DropdownMenuItem>}
            <DropdownMenuItem onClick={() => navigate("/settings")} data-testid="nav-link-settings">Settings</DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={logout} data-testid="logout-button">Sign out</DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};
